import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "vehicle-form-group" }
const _hoisted_2 = { class: "vehicle-form-label" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "vehicle-form-group" }
const _hoisted_5 = { class: "vehicle-form-label" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "vehicle-form-group" }
const _hoisted_8 = { class: "vehicle-form-label" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "vehicle-form-group col-sm-8" }
const _hoisted_12 = { class: "vehicle-form-label" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "vehicle-form-group col-sm-4" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "vehicle-form-group col-sm-6" }
const _hoisted_18 = { class: "vehicle-form-label" }
const _hoisted_19 = { class: "vehicle-form-group col-sm-6" }
const _hoisted_20 = { class: "vehicle-form-label" }
const _hoisted_21 = { class: "vehicle-form-group" }
const _hoisted_22 = { class: "vehicle-form-label" }
const _hoisted_23 = {
  key: 0,
  class: "text-danger small mt-1 mb-0"
}
const _hoisted_24 = { class: "vehicle-form-actions" }

import { ref, computed } from 'vue'
import { Constants } from '@/constants/Constants'
import { StrHelper } from '@/helpers/StrHelper'
import { useI18n } from 'vue-i18n'

interface CreateVehiclePayload {
  plate: string
  brand: string
  model: string
  color: { name: string; hex: string }
  soat_exp?: string
  tec_exp?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleForm',
  props: {
    initialPlate: {}
  },
  emits: ["submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t } = useI18n()

const normalizedPlate = computed(() => StrHelper.formatPlate(props.initialPlate ?? ''))

const brand = ref('')
const model = ref('')
const selectedColorHex = ref<string>(Constants.COLORS[0].hex)
const soat_exp = ref('')
const tec_exp = ref('')
const selectedFile = ref<File | null>(null)
const formError = ref('')

function onFileChange(event: Event): void {
  const file = (event.target as HTMLInputElement).files?.[0] ?? null
  if (!file) return
  if (!['image/jpeg', 'image/png'].includes(file.type)) {
    formError.value = t('validations.image')
    selectedFile.value = null
    return
  }
  if (file.size / 1024 / 1024 > 1.024) {
    formError.value = t('validations.size')
    selectedFile.value = null
    return
  }
  formError.value = ''
  selectedFile.value = file
}

function onSubmit(): void {
  formError.value = ''

  if (!brand.value.trim()) {
    formError.value = t('vehicles.validations.brand_required')
    return
  }
  if (!model.value.trim()) {
    formError.value = t('vehicles.validations.model_required')
    return
  }

  const color = Constants.COLORS.find(c => c.hex === selectedColorHex.value)
  if (!color) {
    formError.value = t('vehicles.validations.color_required')
    return
  }

  const payload: CreateVehiclePayload = {
    plate: normalizedPlate.value,
    brand: brand.value.trim(),
    model: model.value.trim(),
    color: { name: color.name, hex: color.hex },
    soat_exp: soat_exp.value || undefined,
    tec_exp: tec_exp.value || undefined,
  }

  emit('submit', payload, selectedFile.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "vehicle-form",
    onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('vehicles.fields.plate')), 1),
      _createElementVNode("input", {
        class: "vehicle-form-input",
        type: "text",
        value: normalizedPlate.value,
        disabled: "",
        autocomplete: "none"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.$t('vehicles.fields.brand')) + " ", 1),
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "vehicle-form-input",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((brand).value = $event)),
        placeholder: _ctx.$t('vehicles.fields.brand'),
        autocomplete: "none"
      }, null, 8, _hoisted_6), [
        [_vModelText, brand.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", _hoisted_8, [
        _createTextVNode(_toDisplayString(_ctx.$t('vehicles.fields.model')) + " ", 1),
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "vehicle-form-input",
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
        placeholder: _ctx.$t('vehicles.fields.model'),
        autocomplete: "none"
      }, null, 8, _hoisted_9), [
        [_vModelText, model.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("label", _hoisted_12, [
          _createTextVNode(_toDisplayString(_ctx.$t('vehicles.fields.color')) + " ", 1),
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "vehicle-form-input",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedColorHex).value = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Constants).COLORS, (c, key) => {
            return (_openBlock(), _createElementBlock("option", {
              key: key,
              value: c.hex
            }, _toDisplayString(_ctx.$t('common.colors.' + c.name)), 9, _hoisted_13))
          }), 128))
        ], 512), [
          [_vModelSelect, selectedColorHex.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "vehicle-form-label" }, " ", -1)),
        _createElementVNode("input", {
          class: "vehicle-form-color-preview",
          type: "color",
          disabled: "",
          value: selectedColorHex.value
        }, null, 8, _hoisted_15)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('vehicles.fields.soat_exp')), 1),
        _withDirectives(_createElementVNode("input", {
          class: "vehicle-form-input",
          type: "date",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((soat_exp).value = $event)),
          autocomplete: "none"
        }, null, 512), [
          [_vModelText, soat_exp.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('vehicles.fields.tec_exp')), 1),
        _withDirectives(_createElementVNode("input", {
          class: "vehicle-form-input",
          type: "date",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tec_exp).value = $event)),
          autocomplete: "none"
        }, null, 512), [
          [_vModelText, tec_exp.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('vehicles.fields.photo')), 1),
      _createElementVNode("input", {
        class: "vehicle-form-input",
        type: "file",
        accept: "image/jpeg,image/png",
        onChange: onFileChange
      }, null, 32)
    ]),
    (formError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(formError.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("button", {
        type: "button",
        class: "vehicle-form-submit",
        onClick: onSubmit
      }, _toDisplayString(_ctx.$t('common.actions.submit')), 1)
    ])
  ], 32))
}
}

})